import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import {useNavigate, useParams} from "react-router-dom";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import Barcode from "react-barcode";
import Navbar from "../../Layouts/Navbar";
import {SiSearxng} from "react-icons/si";


const Pallet = () => {
    const {pallet} = useParams();
    const navigate = useNavigate();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [products, setProducts] = React.useState([]);
    const [count, setCount] = React.useState(0);
    const [pal, setPal] = React.useState('');
    React.useEffect(() => {
        if (pallet?.length > 5) {
            const params = {
                pallet,
                list: 1,
                count: 1000
            }
            setIsLoaded(false);
            API.getProducts(params)
                .then((response) => {
                    setIsLoaded(true);
                    setProducts(response.data)
                    setCount(response.meta.total)


                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
        else {
            setIsLoaded(true);
        }
    }, [pallet]);



    return (
        <React.Fragment>
            <Navbar page="pallet"/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header title=' مشاهده پالت ها' hasBack={true}/>
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <SiSearxng className='ms-2'/>
                        جستجوی پالت
                    </h1>

                </div>
                <section className="section">
                    <div className="row">

                        <div className="col-12">

                            <div className="card">
                                <div className="card-body py-4">
                                    <div className="row">
                                        <div className="col-12">
                                            <section className="container-fluid  mt-3 py-4 rtl px-0 mx-0 bg-white ">

                                                <div className="row mx-3 my-3 no-print">
                                                    <div className="col-12">
                                                        <div className="card bg-custom">
                                                            <div className="row p-4">
                                                                <div className="col-8">
                                                                    <div className="form-floating mb-3">
                                                                        <input type="number" className="form-control"
                                                                               id="floatingInput"
                                                                               placeholder="Pallet"
                                                                               value={pal}
                                                                               onChange={(val) => {
                                                                                   setPal(val.target.value)
                                                                               }}
                                                                        />
                                                                        <label htmlFor="floatingInput">کد پالت</label>
                                                                    </div>
                                                                </div>
                                                                <div className="col-4">
                                                                    <button className='btn btn-warning w-100'
                                                                            onClick={() => {
                                                                                navigate((`/pallet/${pal}`))
                                                                            }}
                                                                    >
                                                                        مشاهده جزئیات پالت
                                                                    </button>


                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                {
                                                    pallet?.length > 5 &&

                                                    <div className="row m-0 p-0 border-bottom pb-1 mb-1 ">
                                                        <div className="col-4 text-center">
                                                            <Barcode value={pallet} height={20} width={1.3}
                                                                     fontSize={22}/>
                                                        </div>
                                                        <div className="col-3">
                                                            <div className="text-center pt-4">

                                                                {
                                                                    products[0]?.properties[0]?.amperage
                                                                }
                                                                &nbsp;
                                                                آمپر
                                                                &nbsp;
                                                                &nbsp;
                                                                برند:
                                                                &nbsp;
                                                                {
                                                                    products[0]?.brand
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-2 pt-3 fw-bold text-center">
                                                            تعداد :
                                                            &nbsp;
                                                            {count}
                                                        </div>
                                                        <div className="col-3 pt-3 text-small-2  text-start">
                                                            {
                                                                products[0]?.date
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                <div className="row p-0 m-0">
                                                    {
                                                        products?.map(product => {

                                                            return (
                                                                <div className="col-3 text-center p-0 m-0"
                                                                     key={product.code}>
                                                                    <Barcode value={product.code} height={25}
                                                                             width={1.5}
                                                                             fontSize={18}/>
                                                                    <div
                                                                        className='text-center text-small-2 text-muted p-0 m-0'>
                                                                        {product.brand} - {product.properties ? product.properties[0].amperage : ''} Ah
                                                                        -
                                                                        ب.ک:
                                                                        &nbsp;
                                                                        {product.properties ? product.properties[0].open_work : ''}
                                                                        -
                                                                        { product.secondary_group}

                                                                    </div>

                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
        </React.Fragment>
    );
};

export default Pallet;